import { Pipe, PipeTransform } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import {getRoleTitle} from "@utility";

@Pipe({
    name: 'role',
    standalone: false
})
export class RolePipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform = (role?: string) => getRoleTitle(this.translocoService, role);

}
